/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "../Header/header"
import Footer from "../Footer/footer"
import "./layout.css"

const Layout = ({ children }) => (
  <>
    <Header siteTitle="Stop Toxic Housing" />
    <div className="layout">
      <main>{children}</main>
    </div>
    <Footer siteTitle="Stop Toxic Housing" />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
